module.exports = __webpack_public_path__ + "img/pr-3.de3a2b27.png";